import Popover from 'components/shared/Popovers/Popover/Popover';

const ContactButton = ({ children, type }) => {
  return (
    <Popover
      isFixed
      position="left"
      text={`Send ${type === 'phone' ? 'text' : type}`}
      buttonClassName="!bg-primary-500"
      buttonTheme="primary"
      textClassName="text-white"
      activeClassNames={{
        button: '!bg-primary-700 hover:!bg-primary-700'
      }}
      icon={false}>
      {children}
    </Popover>
  );
};

export default ContactButton;
